import { useNavigate } from 'react-router-dom';
import '../css/PaymentResult.css';

const PaymentCancel = () => {
  const navigate = useNavigate();
  
  return (
    <div className="payment-cancel-container">
      <h1>Payment Cancelled</h1>
      <p>Your payment process was cancelled.</p>
      <p>If you have any questions or need assistance, please contact our support team.</p>
      <button 
        onClick={() => navigate('/')}
        className="home-button"
      >
        Return to Home
      </button>
    </div>
  );
};

export default PaymentCancel;